export enum ReservationStatus {
	APPROVED = "APPROVED",
	CANCELED_BY_STORE = "CANCELED_BY_STORE",
	CANCELED_BY_CUSTOMER = "CANCELED_BY_CUSTOMER",
	WAITING_APPROVAL = "WAITING_APPROVAL",
	BLOCKED = "BLOCKED",
	STORE_CLOSED = "STORE_CLOSED",
	NOT_AVAILABLE = "NOT_AVAILABLE",
	AVAILABLE = "AVAILABLE"
}



// WEBPACK FOOTER //
// ./src/app/pages/reservation/enums/reservation-status.enum.ts